const HEADER_NAVIGATOR_ROUTER = [
  {
    seq: 0,
    label: 'TMS',
    to: process.env.REACT_APP_TMS_URL,
  },
];

export default HEADER_NAVIGATOR_ROUTER;
